import React, { useEffect, useState } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import {
  admin_faq_edit,
  admin_membership_edit,
  get_faq_details,
  get_membership_details,
} from "../admin.api";
import { useParams } from "react-router-dom";

import "./view.css";
import { FormValidate } from "../../../components/formValidate";
import TextEditer from "../../../components/inputs/texteditor";
let required = ["question", "answer", "question_ma", "answer_ma"];
export default function EditFaq(props) {
  const [basicData, setBasicData] = useState({});
  const selectedParam = useParams();
  const getFaqDtails = () => {
    if (!selectedParam?.id) {
      console.error("selectedParam.id is undefined:", selectedParam);
      return;
    }
    get_faq_details(selectedParam.id)
      .then((res) => {
        if (res?.faq) {
          setBasicData(res?.faq);
        }
      })
      .catch((err) => console.error("Error fetching Membership details:", err));
  };

  useEffect(() => {
    getFaqDtails();
  }, [selectedParam]);
  useEffect(() => {
    if (selectedParam?.id) {
      get_faq_details(selectedParam.id)
        .then((res) => {
          if (res?.faq) {
            setBasicData(res.faq);
          }
        })
        .catch((err) => console.error("Error fetching FAQ details:", err));
    }
  }, [selectedParam]);

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [fileChanged, setFileChanged] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const handleChange = (e) => {
    let { name, value } = e.target;
    setBasicData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhotoFileChange = (e) => {
    let flag = false;
    let type = e.target.files[0].name.split(".").pop();

    if (type === "png" || type === "jpeg" || type === "jpg") {
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;

        image.onload = function () {
          var height = this.height;
          var width = this.width;

          if (height === 400 || width === 400) {
            flag = true;
          }
        };
      };
      setTimeout(() => {
        if (flag) {
          setFileChanged(true);
          setBasicData({
            ...basicData,
            file_name_photo: e.target.files[0].name,
            [e.target.name]: e.target.files[0],
          });
        } else {
          setSnackMessage("Incorrect image dimension");
          setIsSnackError(true);
          setSnackOpen(true);
        }
      }, 200);
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png format");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = FormValidate(basicData, required);
    setIsActive(true);
    if (Object.keys(errors).length === 0) {
      let id = basicData.id;

      const payload = {
        id: basicData?.id,
        question: basicData?.question?.trim(),
        answer: basicData?.answer?.trim(),
        question_ma: basicData?.question_ma?.trim(),
        answer_ma: basicData?.answer_ma?.trim(),

      };
      if (basicData.question === '<p><br></p>') {
        setSnackMessage("Question  in English is Required");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        return;
      }
      else if (basicData.answer === '<p><br></p>') {
        setSnackMessage("Question in Malayalam is Required");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        return;
      }
      else if (basicData.answer === '<p><br></p>') {
        setSnackMessage("Answer in English is Required");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        return;
      }

      else if (basicData.answer === '<p><br></p>') {
        setSnackMessage("Answer in Malayalam is Required");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
        return;
      }

      try {
        const res = await admin_faq_edit(id, payload);
        setSnackMessage("FAQ Edited Successfully");
        setIsSnackError(false);
        setSnackOpen(true);
      } catch (error) {
        setSnackMessage(error.response?.data?.message || "Error updating FAQ");
        setIsSnackError(true);
        setSnackOpen(true);
      } finally {
        setIsActive(false);
      }
    } else {
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/faq-list");
    }
  };

  return (
    <div className="add-per">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <h6>
          <b>Edit FAQ</b>
        </h6>
        <hr />
        <button
          type="button"
          className="btn btn-primary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/faq-list");
          }}
        >
          Back
        </button>

        <div className="row">
          <div className="col-12">
            <TextEditer
              key={basicData?.id}
              fullwidth
              label="Question[English]"
              required
              value={basicData?.question || ""}
              onChange={(value) =>
                setBasicData((prev) => ({ ...prev, question: value }))
              }
              name="question"
              id="question"
              multiline
            />
          </div>
          <div className="col-12">

            <TextEditer
              key={basicData?.id}
              label="Question[Malayalam]"
              value={basicData?.question_ma || undefined}
              name="question_ma"
              id="question_ma"
              required
              onChange={(value) => setBasicData((prev) => ({ ...prev, question_ma: value }))
              }
            />
          </div>
          <div className="col-12">
            <TextEditer
              key={basicData?.id}
              fullwidth
              label="Answer[English]"
              required
              value={basicData?.answer || ""}
              onChange={(value) =>
                setBasicData((prev) => ({ ...prev, answer: value }))
              }
              name="answer"
              id="answer"
              multiline
            />
          </div>
          <div className="col-12">

            <TextEditer
              key={basicData?.id}
              label="Answer[Malayalam]"
              value={basicData?.answer_ma || undefined}
              name="answer_ma"
              id="answer_ma"
              required
              onChange={(value) => setBasicData((prev) => ({ ...prev, answer_ma: value }))}
            />
          </div>

          <div className="col-12">
            <center>
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={(e) => handleSubmit(e)}
              >
                Submit for Acceptance
              </button>
            </center>
          </div>
          {/* ---------------- */}
        </div>
      </div>
    </div>
  );
}
